<template>
  <span class="dataLabel break-word ">{{ valueString }}<slot /></span>
</template>

<script setup lang="ts">
import {computed} from "vue";
import moment from "moment/moment";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";


interface Props {
  value?: any
  valueType?: SogDataLabelValueType
}

const props = withDefaults(defineProps<Props>(), {value: undefined, valueType: undefined})

/*
defineProps({
  value: any,
  valueType: String as PropType<ValueType>
})
*/

const valueString = computed(() => {
  if (props.value || props.value === 0) {
    if (props.valueType === SogDataLabelValueType.DateTime) {
      return moment(props.value).format("DD.MM.YYYY HH:mm:ss");
    } else if (props.valueType === SogDataLabelValueType.Date) {
      return moment(props.value).format("DD.MM.YYYY");
    } else if (props.valueType === SogDataLabelValueType.Money && props.value) {
      const val = props.value
      return Number(val).toLocaleString("de-DE", {style: 'currency', currency: 'EUR'});
    }
    return props.value
  }
  return "";
})
</script>

<style>
/*
.dataLabel {
//font-weight: bold; padding-left: 5px; border: 1px solid rgba(128, 128, 128, 0.584); //border-radius: 5px; //width: 100%; //min-height: 30px; //display: flex; //align-items: center;


}
*/

.break-word {
  word-wrap: anywhere;
}
</style>
